
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kdsihrnihpkhalrmholp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imtkc2locm5paHBraGFscm1ob2xwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDczNzAxMjcsImV4cCI6MjA2Mjk0NjEyN30.CuQZQ9QnBms9spf9BgwpPoXAS1hs_Zv1lIoFUd3itXk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});

// Create a reusable function to get a collaboration channel
export const getCollaborationChannel = (whiteboardId: string) => {
  return supabase.channel(`whiteboard-${whiteboardId}`, {
    config: {
      broadcast: {
        self: false
      }
    }
  });
};
